import React from 'react';

import { makeRich } from '../../util/richText';
import style from './EditMyInfoCompleteModal.module.scss';
import { Button } from '../../soonmoo';
import { ModalVIcon } from '../Icon';
import { useTranslation } from 'react-i18next';

interface EditMyInfoCompleteModalProps {
  onDismiss?(): any;
}

export function EditMyInfoCompleteModal(props: EditMyInfoCompleteModalProps) {
  const { t } = useTranslation();
  return (
        <div className={style.wrapper}>
            <div className={style.dim} />
            <div className={style.modal}>
                <ModalVIcon className={style.doneIcon} />
                <h1>{t('휴대전화 번호 변경 완료')}</h1>
                <p>
                    {makeRich(
                        t(
                            '휴대전화 번호 변경이 완료되었습니다.\n' +
                                '이전 번호로 적립한 내역은 <b>영업일 기준 24시간 이후에 반영됩니다.</b>',
                        ),
                    )}
                </p>
                <Button kind="default" className={style.ok} onClick={props.onDismiss}>
                    {t('확인')}
                </Button>
            </div>
        </div>
  );
}
